import { Component, OnInit } from '@angular/core';
import { UsersService } from './../routes/users/users.service';
import {Router} from "@angular/router";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CustomValidators} from "ng2-validation";
import {Toast, ToasterService} from "angular5-toaster/dist";

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.less']
})
export class ForgotComponent implements OnInit {

  forgotPassword: string;
  valForm: FormGroup;
  disabled: boolean = false;
  hideButton: boolean = false;

  constructor(private usersService: UsersService, private router: Router, private fb: FormBuilder, private toasterService: ToasterService) { }

  ngOnInit() {
    this.valForm = this.fb.group({
      'email': [null, Validators.compose([Validators.required, Validators.maxLength(50), CustomValidators.email])],
    });
  }

  resetPassword() {
    for (const c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }

    if (this.valForm.valid) {
      this.disabled = true;
      this.usersService.forgotPassword(this.forgotPassword).subscribe(
        (response) => {
          this.hideButton = true;
            const toast: Toast = {
              type: 'success',
              title: 'Success',
              body: 'We have sent you an email with a reset password link',
              showCloseButton: true,
              timeout: 5000
            };

            this.toasterService.pop(toast);
        },
        (error) => {
          this.hideButton = false;
          this.disabled = false;
          // console.log(error);
        }
      );
    }
  }

  redirectToLogin(){
    this.router.navigate(['/login']);
  }

}



// WEBPACK FOOTER //
// ./src/app/forgot/forgot.component.ts